<template>
  <div class="py-12" v-if="items.length">
    <v-sheet class="px-3 mx-auto" max-width="1200px" width="100%">
      <custom-title class="mb-5" align="center">Nossas Máquinas</custom-title>
      
      <div class="mx-n2">
        <CarouselWidget
          class="mb-16"
          :items="items"
          :itemsToShow="itemsToShow"
          dots
          spacing="px-2"
        >
          <template #item="{ item }">
            <product-card v-bind="item"></product-card>
          </template>
        </CarouselWidget>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import CustomTitle from "../../shell/CustomTitle.vue";
import CarouselWidget from "../../widgets/CarouselWidget.vue";
import ProductCard from "../../cards/Product.vue";
import { formatToURL } from "../../utils";

const _config = {
  mod: "products",
  path: "/maquinas",
};

const _data = {
  itemsToShow: {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 3,
    xl: 3,
  },
};

export default {
  data: () => ({
    path: _config.path,
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list
        .filter((item) => item && item.title)
        .map(({ id, title, img, category }) => {
          const safeTitle = String(title || "");
          return {
            title: safeTitle,
            img: this.files + String(img || ""),
            category: String((category && category.title) || ""),
            to: `${_config.path}/${formatToURL(safeTitle)}-${id}`,
          };
        });
    },
    smOnly() {
      return this.$vuetify.breakpoint.smOnly;
    },
  },
  beforeCreate() {
    const params = {
      itemsPerPage: 12,
    };

    this.$rest(_config.mod).get({ params });
  },
  components: {
    CustomTitle,
    CarouselWidget,
    ProductCard,
  },
};
</script>

<style>
</style>
